/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Akcja, która utworzyła lub zamyka zadanie
 * @export
 * @enum {string}
 */

export const TaskTriggerDto = {
    Manual: 'MANUAL',
    DevelopmentStepInProgress: 'DEVELOPMENT_STEP_IN_PROGRESS',
    DevelopmentStepOverdue: 'DEVELOPMENT_STEP_OVERDUE',
    DevelopmentPlanRequired: 'DEVELOPMENT_PLAN_REQUIRED',
    DevelopmentPlanReviewRequired: 'DEVELOPMENT_PLAN_REVIEW_REQUIRED',
    DevelopmentPlanInitiationRequired: 'DEVELOPMENT_PLAN_INITIATION_REQUIRED'
} as const;

export type TaskTriggerDto = typeof TaskTriggerDto[keyof typeof TaskTriggerDto];



